// Language configuration - all possible languages
export const ALL_LANGUAGES = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "cs", name: "Čeština", flag: "🇨🇿" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "pl", name: "Polski", flag: "🇵🇱" },
  { code: "sk", name: "Slovenčina", flag: "🇸🇰" },
  { code: "hu", name: "Magyar", flag: "🇭🇺" },
] as const;

export type LanguageCode = typeof ALL_LANGUAGES[number]["code"];

export const PRIMARY_LANGUAGE: LanguageCode = "en";

export const getLanguageInfo = (code: string) => {
  return ALL_LANGUAGES.find(l => l.code === code);
};

export const getLanguageName = (code: string): string => {
  return getLanguageInfo(code)?.name || code;
};

export const getLanguageFlag = (code: string): string => {
  return getLanguageInfo(code)?.flag || "";
};
